

export const index = 7;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/docs/getting-started/installation/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/7.COqmbwhx.js","_app/immutable/chunks/mtF927Wn.js","_app/immutable/chunks/C8t-7i39.js","_app/immutable/chunks/IHki7fMi.js","_app/immutable/chunks/Ch3kBo8q.js","_app/immutable/chunks/DW5DwYHW.js"];
export const stylesheets = ["_app/immutable/assets/7.K3VfHWXn.css"];
export const fonts = [];
